import styled from 'styled-components';
import type { ThemeTypes } from '../../../../../types/Theme.namespace';

const Wrapper = styled.div<{ gap?: ThemeTypes.Spacing }>`
  margin-bottom: ${({ theme, gap }) => (gap ? theme.spacing[gap] : 0)};
`;

export { Wrapper };
